module.exports = __webpack_public_path__ + "img/nightclub.c4d64508.png";